module.exports = __webpack_public_path__ + "static/media/flooring4.f202495e.jpg";